// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1n-Hz","question":"styles_question__2LS7L","inputVisibleButton":"styles_inputVisibleButton__31yR-","note":"styles_note__e3xaf"};